import { useEffect, useState } from "react";
import { ServiceTile } from "../components/ServiceTile";
import { Link, useLoaderData, useNavigate } from "react-router-dom"
import { _getTicketStatusOptions, addTicketPayment, deleteOrderTicket, deleteServiceTicket } from "../services/api";
import { Select } from "../components/Select";
import { TextField } from "../components/TextField";
import { Form } from "react-router-dom";
import { Button } from "../components/Button";
import { formatDate, getUserId, getUserPermission } from "../services/helpers";
import mixpanel from "../services/mixpanel";





function renderServiceList(filteredServices,statusFilter,typeFilter,searchFilter,confirmDeleteService,showPaymentDialog){

	return (
		<div className="customer-list">
			{(filteredServices.length === 0) ? <h3 className="mt-1">No Service Tickets in the  `{statusFilter}` category</h3> :filteredServices.map(service => (
				<ServiceTile
					key={`${service.ticket_type}${service.ticket_id}`}
					service={service}
					onDeleteClick={()=>confirmDeleteService(service.ticket_id, service.ticket_type)}
					onPaymentClick={()=> showPaymentDialog(service.ticket_type, service.ticket_id)}
				/>
			))}
		</div>
	);
}



export function Services(){
	const loaderData = useLoaderData();
	const combined = loaderData.all_tickets.data;
	const navigate = useNavigate();
	const userPermission = getUserPermission();


	const [statusList,setStatusList] = useState([]);
	const [statusFilter,setStatusFilter] = useState(null);
	const [typeFilter,setTypeFilter] = useState(null);
	const [searchFilter,setSearchFilter] = useState("");
	const [showDialog,setShowDialog] = useState(false);
	const [showPaymentDialog,setShowPaymentDialog] = useState(null);
	const [paymentTicketId,setPaymentTicketId] = useState(null);
	const [_deleteServiceId,_setDeleteServiceId] = useState(null);
	const [_deleteServiceType,_setDeleteServiceType] = useState(null);
	const [_filterStartDate, _setFilterStartDate] = useState(null);
	const [_filterEndDate, _setFilterEndDate] = useState(null);
	const [_showDateFilterPop,_setShowDateFilterPopup] = useState(false);


	let filteredServices = combined.filter(service =>
		(!statusFilter || service.status === statusFilter) &&
		(!typeFilter || service.ticket_type === typeFilter) &&
		(!searchFilter.trim() ||
			`${service.customer_name}`.toLowerCase().includes(searchFilter.trim().toLowerCase()) ||
			service.license_plate?.toLowerCase().includes(searchFilter.trim().toLowerCase())
		) &&
		(!_filterStartDate || new Date(service.date_created) >= new Date(_filterStartDate)) &&
		(!_filterEndDate || new Date(service.date_created) <= new Date(_filterEndDate))
	);

	function updateStatusFilter(filter){
		if (statusList.includes(filter)){
		setStatusFilter(filter);
		}else{
			setStatusFilter(null)
		};
	}
	function updateTypeFilter(filter){
		if (["order","service"].includes(filter)){
		setTypeFilter(filter);
		}else{
			setTypeFilter(null)
		};
	}


	const openPaymentDialog = (type,id) => {
		setShowPaymentDialog(type );
		setPaymentTicketId(id);

	}

	const confirmDeleteService = async (ticket_id,ticket_type) => {
		_setDeleteServiceId(ticket_id);
		_setDeleteServiceType(ticket_type);
		setShowDialog(true);
	};

	const handleCloseDialog = () => {
		setShowDialog(false);

	};

	const deleteService = async ()=> {
		if (_deleteServiceType == "service"){
			const response = await deleteServiceTicket(_deleteServiceId);
			alert(response.msg);
		}else if (_deleteServiceType == "order"){
			const response = await deleteOrderTicket(_deleteServiceId);
			alert(response.msg);
		}
		setShowDialog(false);


	}

	function submitTicketPayment(e){
		e.preventDefault();
		const form = document.getElementById("addTicketPaymentForm");
		const formData = new FormData(form);

		const payload = {
			ticket_id: paymentTicketId,
			currency: formData.get("currency"),
			amount: formData.get("amount"),
			payment_method: formData.get("payment_method"),
			payment_date: formData.get("payment_date"),
			reference: formData.get("reference"),
			ticket_type: showPaymentDialog
		};

		addTicketPayment(payload).then(async(result)=>{
			let message = await result.json();
			alert(message.msg);
			setShowPaymentDialog(null);
		});

	}


	useEffect(()=>{
		mixpanel.identify(getUserId());
		_getTicketStatusOptions().then((statuses)=>{
			const map = statuses.statuses.map((stat)=>stat.status);
			setStatusList(map);

		});

	},[]);




	return (
		<main>
		<h1>Service Tickets ({filteredServices.length})</h1>

		<div className="row" id="page-actions">
			<TextField
			label="Filter by name or License plate"
				hint="Customer Name or License Plate"
				value={searchFilter}
				onChange={(value)=>{setSearchFilter(value.target.value);}}
			/>
			<Select
				label="Filter by type"
				options={["All", "order","service"]}
				onChange={(selected)=> updateTypeFilter(selected.target.value)}
			/>
			<Select
				label="Filter by status"
				options={["All", ...statusList.map((stat) => stat)]}
				onChange={(selected)=> updateStatusFilter(selected.target.value)}
			/>

			<div className="popup-container">
				<button className="link" onClick={()=> _setShowDateFilterPopup(prev=>!prev)}> Filter By Date</button>
				{_showDateFilterPop && <span className="popup">
					<TextField
						label="Start Date"
						value={_filterStartDate ?? ""}
						type="date"
						onChange={(e)=> _setFilterStartDate(e.target.value)}
					/>
					<TextField
						label="End Date"
						value={_filterEndDate ?? ""}
						type="date"
						onChange={(e)=> _setFilterEndDate(e.target.value)}
					/>
					<div className="row space-between">
						<button className="link red-text" onClick={()=>{
							_setFilterStartDate(null);
							_setFilterEndDate(null);
							_setShowDateFilterPopup(false);
						}}>Reset</button>
						<button className="link" onClick={()=>_setShowDateFilterPopup(false)}>Close</button>
					</div>
				</span>}
			</div>
		</div>

		{/* {renderServiceList(filteredServices,statusFilter,typeFilter,searchFilter,confirmDeleteService,openPaymentDialog)} */}
		<table>
			<thead>
				<th>Vehicle</th>
				<th>Customer</th>
				<th>Service Date</th>
				<th>Invoice Total</th>
				<th>Status</th>
				<th>Actions</th>
			</thead>
			<tbody>
				{filteredServices.map(service=>
					<tr>
						<td className="clickable" onClick={()=>service.license_plate && navigate(`/dashboard/vehicles/${service.license_plate}/services`)}> {service.vehicle_name ? <>{service.vehicle_name} <small>({service.license_plate})</small></> : "Order Ticket"}</td>
						<td className="clickable" onClick={()=> navigate(`/dashboard/members/u/${service.customer_id}/vehicles`)}>{service.customer_name}</td>
						<td>{formatDate(service.date_created,false)}</td>
						<td><strong >GHS</strong> <span className={service.total_paid < service.total_invoice ? "red-text" : "blue-text"}>{service.total_paid}</span> <strong>/{service.total_invoice ?? 0}</strong></td>
						<td><span className={`status-card ${service.status?.replaceAll(" ","-")}`}>{service.status}</span></td>
						<td>
							<div className="action-section col">
			<Link className="" to={service.ticket_type === "service" ? `/dashboard/services/${service.license_plate}/${service.ticket_id}` : `/dashboard/members/u/${service.customer_id}/${service.ticket_id}`}>Details </Link>
			{openPaymentDialog && <button className="link" onClick={openPaymentDialog}>Record Payment </button>}
			{userPermission === "admin" && confirmDeleteService != null &&  <button className="link red-text"  onClick={confirmDeleteService}>Delete Service Ticket </button>}
		</div>
						</td>
					</tr>
				)}
			</tbody>
		</table>


			{showDialog && (
				<div className="dialog-overlay">

					<div className="dialog" >
						<Form id="addServiceItemForm">
							<div className="dialog-header">
								<h3>Are You sure you want to delete the {_deleteServiceType} Ticket {_deleteServiceId}</h3>
							</div>
							<div className="dialog-footer">
								<Button onClick={handleCloseDialog} label="Cancel" color="green" />
								<Button onClick={deleteService} color="red" label="Delete"/>
							</div>
						</Form>
					</div>
				</div>
			)}

			{showPaymentDialog && (
				<div className="dialog-overlay">

					<div className="dialog" >
						<Form id="addTicketPaymentForm" onSubmit={submitTicketPayment}>
							<div className="dialog-header">
								<h3>Add Payment for Service</h3>
							</div>
							<div className="dialog-body">

								<div className="row-2">
									<Select
										label="Currency"
										name="currency"
										options={["GHS","USD"]}
									/>

									<TextField
										label="Amount"
										name="amount"
										type={"number"}
									/>
								</div>

								<div className="row-2">
									<Select
										label={"Payment method"}
										name="payment_method"
										options={["Cash","Paystack","Zipbooks"]}
									/>

									<TextField
										label="Payment Date"
										name="payment_date"
										type={"date"}
									/>

								</div>


								<TextField
									label="Reference"
									type={"text"}
									name="reference"
								/>
							</div>
							<div className="dialog-footer">
								<Button onClick={()=>setShowPaymentDialog(null)} color="red" label="Cancel"/>
								<Button type="submit" label="Record Payment" color="green" />
							</div>
						</Form>
					</div>
				</div>
			)}


		</main>
	)
}